module.exports = __webpack_public_path__ + "static/img/6.e142dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/6.jpg
// module id = KcI4
// module chunks = 0